<template>
  <div id="app">
    <component :is="layout" component="root">
      <router-view/>
    </component>
  </div>
</template>
<script>
const defaultLayout = 'default'
export default {
  computed: {
    layout () {
      return (this.$route.meta.layout || defaultLayout) + '-layout'
    }
  },
  mounted() {
    this.updateVH();
    window.addEventListener('resize', this.updateVH);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateVH);
  },
  methods: {
    updateVH() {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    }
  }
}
</script>
<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
body, #app {
  height: calc(var(--vh, 1vh) * 100);
  overflow-y: auto;
}

</style>



// WEBPACK FOOTER //
// src/App.vue